import {
  GETMODULEVIASTATUS,
  axios,
  baseURL,
  GETHOSPITAL,
  GETHOSPITALBYID,
  CREATEHOSPITAL,
  UPDATEHOSPITAL,
  CREATENOTIFICATION,
  GETNOTIFICATION,
  UPDATENOTIFICATION,
  DELETENOTIFICATION,
  GETSMS1,
  UPDATESMS1,
  GETSMS2,
  UPDATESMS2,
  GETSMS3,
  UPDATESMS3,
  GETSMS4,
  UPDATESMS4,
  GETSMS5,
  UPDATESMS5,
  GETSMS6,
  UPDATESMS6,
  GETSMS7,
  UPDATESMS7,
  DELETESMS1,
  DELETESMS2,
  DELETESMS3,
  DELETESMS4,
  DELETESMS5,
  DELETESMS6,
  DELETESMS7,
  GETEMAIL,
  CREATEEMAIL,
  UPDATEEMAIL,
  DELETEEMAIL,
  GETPAYMENT1,
  UPDATEPAYMENT1,
  GETPAYMENT2,
  UPDATEPAYMENT2,
  GETPAYMENT3,
  UPDATEPAYMENT3,
  GETPAYMENT4,
  UPDATEPAYMENT4,
  GETPAYMENT5,
  UPDATEPAYMENT5,
  GETPAYMENT6,
  UPDATEPAYMENT6,
  GETPAYMENT7,
  UPDATEPAYMENT7,
  GETPAYMENT8,
  UPDATEPAYMENT8,
  GETPAYMENT9,
  UPDATEPAYMENT9,
  GETPAYMENT10,
  UPDATEPAYMENT10,
  GETPAYMENT11,
  UPDATEPAYMENT11,
  GETPAYMENT12,
  UPDATEPAYMENT12,
  GETPAYMENT13,
  UPDATEPAYMENT13,
  GETPAYMENT14,
  UPDATEPAYMENT14,
  GETPAYMENT15,
  UPDATEPAYMENT15,
  GETPAYMENT16,
  UPDATEPAYMENT16,
  DELETEPAYMENT1,
  DELETEPAYMENT2,
  DELETEPAYMENT3,
  DELETEPAYMENT4,
  DELETEPAYMENT5,
  DELETEPAYMENT6,
  DELETEPAYMENT7,
  DELETEPAYMENT8,
  DELETEPAYMENT9,
  DELETEPAYMENT10,
  DELETEPAYMENT11,
  DELETEPAYMENT12,
  DELETEPAYMENT13,
  DELETEPAYMENT14,
  DELETEPAYMENT15,
  DELETEPAYMENT16,
  CREATESMS1,
  CREATESMS2,
  CREATESMS3,
  CREATESMS4,
  CREATESMS5,
  CREATESMS6,
  CREATESMS7,
  CREATEPAYMENT1,
  CREATEPAYMENT2,
  CREATEPAYMENT3,
  CREATEPAYMENT4,
  CREATEPAYMENT5,
  CREATEPAYMENT6,
  CREATEPAYMENT7,
  CREATEPAYMENT8,
  CREATEPAYMENT9,
  CREATEPAYMENT10,
  CREATEPAYMENT11,
  CREATEPAYMENT12,
  CREATEPAYMENT13,
  CREATEPAYMENT14,
  CREATEPAYMENT15,
  CREATEPAYMENT16,
  GETPAYMENT18,
  CREATEPAYMENT18,
  UPDATEPAYMENT18,
  DELETEPAYMENT18,
  GETPREFIX,
  CREATEPREFIX,
  UPDATEPREFIX,
  DELETEPREFIX,
  GETROLE,
  CREATEROLE,
  UPDATEROLE,
  DELETEROLE,
  GETBACKUP,
  CREATEBACKUP,
  UPDATEBACKUP,
  DELETEBACKUP,
  GETLANGUAGE,
  CREATELANGUAGE,
  UPDATELANGUAGE,
  DELETELANGUAGE,
  GETPATIENT,
  CREATEPATIENT,
  UPDATEPATIENT,
  DELETEPATIENT,
  GETSTAFF,
  CREATESTAFF,
  UPDATESTAFF,
  DELETESTAFF,
  GETCAPTCHA,
  CREATECAPTCHA,
  UPDATECAPTCHA,
  DELETECAPTCHA,
  GETMODULE,
  GETMODULEADMIN,
  CREATEMODULE,
  UPDATEMODULE,
  DELETEMODULE,
  GETALLMODULE,
  CREATECHILDRENMODULE,
  GETCHILDRENMODULE,
  GETCHILDRENMODULEADMIN,
  UPDATECHILDRENMODULE,
  DELETECHILDRENMODULE,
  GETALLCHILDRENMODULE,
  CREATEBRANCH,
  GETBRANCH,
  UPDATEBRANCH,
  DELETEBRANCH,
  SET_SELECTED_BRANCH,
  CREATEADMINEMODULE,
  CREATEADMINCHILDRENMODULE,
  BULK_CREATE_MASTER_DATA,
  SYNC_BULK_MODULES,
  UPDATEALLMODULEANDCHILD
} from "./types";


export const setSelectedBranch = (hospitalCode) => (dispatch) => {
  console.log("[ACTION] setSelectedBranch: Dispatching with hospitalCode ->", hospitalCode);
  dispatch({
    type: "SET_SELECTED_BRANCH",
    payload: hospitalCode,
  });
};



export const updateSms1 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupsms/updatesms1",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATESMS1,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const getSms1 = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/getallsms1",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETSMS1,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createSms1 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/createsms1",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESMS1,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createSms2 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/createsms2",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESMS2,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createSms3 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/createsms3",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESMS3,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createSms4 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/createsms4",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESMS4,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createSms5 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/createsms5",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESMS5,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createSms6 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/createsms6",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESMS6,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createSms7 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/createsms7",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESMS7,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateSms2 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupsms/updatesms2",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATESMS2,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSms2 = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/getallsms2",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETSMS2,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSms3 = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/getallsms3",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETSMS3,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateSms3 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupsms/updatesms3",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATESMS3,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSms4 = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/getallsms4",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETSMS4,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateSms4 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupsms/updatesms4",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATESMS4,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSms5 = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/getallsms5",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETSMS5,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateSms5 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupsms/updatesms5",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATESMS5,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateSms6 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupsms/updatesms6",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATESMS6,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSms6 = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/getallsms6",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETSMS6,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateSms7 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupsms/updatesms7",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATESMS7,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSms7 = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupsms/getallsms7",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETSMS7,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteSms1 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupsms/delete1",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETESMS1,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteSms2 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupsms/delete2",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETESMS2,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteSms3 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupsms/delete3",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETESMS3,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteSms4 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupsms/delete4",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETESMS4,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteSms5 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupsms/delete5",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETESMS5,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteSms6 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupsms/delete6",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETESMS6,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteSms7 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupsms/delete7",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETESMS7,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createNotification = (Notificationdata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupnotification/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Notificationdata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATENOTIFICATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const getNotification = (data) => (dispatch) => {
  // var data = JSON.stringify({
  // });
  var config = {
    method: "post",
    url: baseURL + "/api/setupnotification/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETNOTIFICATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateNotification = (Notificationdata) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupnotification/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Notificationdata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATENOTIFICATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const deleteNotification = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupnotification/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETENOTIFICATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const getHospitalById = (hospitaldata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupsetting/byid",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: hospitaldata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETHOSPITALBYID,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const getHospital = () => (dispatch) => {
  var data = JSON.stringify({});
  var config = {
    method: "post",
    url: baseURL + "/api/setupsetting/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETHOSPITAL,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const setHospital = (Hospitaldata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupsetting/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Hospitaldata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEHOSPITAL,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateHospital = (Hospitaldata) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupsetting/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Hospitaldata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEHOSPITAL,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const createEmail = (Emaildata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupemail/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Emaildata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEEMAIL,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const getEmail = (data) => (dispatch) => {
  // var data = JSON.stringify({
  // });
  var config = {
    method: "post",
    url: baseURL + "/api/setupemail/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETEMAIL,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateEmail = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupemail/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEEMAIL,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteEmail = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupemail/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEEMAIL,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPrefix = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupprefix/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPREFIX,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPrefix = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupprefix/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPREFIX,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePrefix = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupprefix/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPREFIX,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePrefix = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupprefix/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPREFIX,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment1 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment1",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT1,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment1 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment1",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT1,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment2 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment2",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT2,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment2 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment2",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT2,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment3 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment3",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT3,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment3 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment3",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT3,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment4 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment4",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT4,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment4 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment4",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT4,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment5 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment5",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT5,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment5 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment5",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT5,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment6 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment6",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT6,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment6 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment6",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT6,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment7 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment7",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT7,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment7 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment7",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT7,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment8 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment8",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT8,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment8 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment8",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT8,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment9 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment9",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT9,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment9 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment9",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT9,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment10 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment10",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT10,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment10 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment10",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT10,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment11 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment11",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT11,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment11 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment11",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT11,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment12 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment12",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT12,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment12 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment12",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT12,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment13 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment13",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT13,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment13 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment13",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT13,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment14 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment14",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT14,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment14 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment14",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT14,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment15 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment15",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT15,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment15 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment15",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT15,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment16 = (data) => (dispatch) => {
  //var data = JSON.stringify({});
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment16",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT16,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment16 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment16",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT16,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment1 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT1,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment2 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete2",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT2,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment3 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete3",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT3,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment4 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete4",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT4,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment5 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete5",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT5,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment6 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete6",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT6,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment7 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete7",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT7,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment8 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete8",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT8,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment9 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete9",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT9,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment10 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete10",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT10,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment11 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete11",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT11,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment12 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete12",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT12,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment13 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete13",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT13,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment14 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete14",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT14,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment15 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete15",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT15,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePayment16 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete16",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT16,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment1 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment1",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT1,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment2 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment2",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT2,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment3 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment3",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT3,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment4 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment4",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT4,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment5 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment5",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT5,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment6 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment6",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT6,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment7 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment7",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT7,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment8 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment8",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT8,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment9 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment9",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT9,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment10 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment10",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT10,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment11 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment11",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT11,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment12 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment12",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT12,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment13 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment13",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT13,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment14 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment14",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT14,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment15 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment15",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT15,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment16 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment16",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT16,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createRole = (Roledata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuprole/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Roledata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEROLE,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const getRole = (data) => (dispatch) => {
  // var data = JSON.stringify({
  // });
  var config = {
    method: "post",
    url: baseURL + "/api/setuprole/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETROLE,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const updateRole = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuprole/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEROLE,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const deleteRole = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuprole/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEROLE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createBackup = (Backupdata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupbackup/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Backupdata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEBACKUP,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getBackup = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupbackup/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETBACKUP,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateBackup = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupbackup/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEBACKUP,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteBackup = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupbackup/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEBACKUP,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createLanguage = (Languagedata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuplanguage/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Languagedata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATELANGUAGE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getLanguage = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setuplanguage/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETLANGUAGE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateLanguage = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuplanguage/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATELANGUAGE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteLanguage = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuplanguage/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETELANGUAGE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPatient = (Patientdata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppatient/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Patientdata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPATIENT,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPatient = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setuppatient/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPATIENT,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePatient = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppatient/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPATIENT,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deletePatient = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppatient/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPATIENT,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createStaff = (Staffdata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupstaff/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Staffdata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESTAFF,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStaff = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupstaff/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETSTAFF,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateStaff = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupstaff/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATESTAFF,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteStaff = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupstaff/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETESTAFF,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createCaptcha = (Captchadata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupcaptcha/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Captchadata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATECAPTCHA,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCaptcha = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupcaptcha/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETCAPTCHA,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateCaptcha = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupcaptcha/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATECAPTCHA,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteCaptcha = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupcaptcha/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETECAPTCHA,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createModule = (Moduledata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupmodule/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Moduledata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getModule = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupmodule/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getallModule = (UserData) => (dispatch) => {
  var config = {
    method: "post",
    // url: baseURL+'/api/users/userrole',
    // url: baseURL + "/api/setupmodule/getallmodule",
    url: baseURL + "/api/setupmodule/getallmod",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: UserData,
  };

  axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data));
      dispatch({
        type: GETALLMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getModuleViaStatus = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupmodule/getalldetails ",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETMODULEVIASTATUS,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getModuleAdmin = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupmodule/getalladmin",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETMODULEADMIN,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateModule = (data) => (dispatch) => {
  var config = {
    method: "patch",
    // url: baseURL + "/api/setupmodule/update",
    url: baseURL + "/api/setupmodule/updateall",

    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteModule = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupmodule/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

//
export const createChildrenModule = (Moduledata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupchildrenmodule/createall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Moduledata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATECHILDRENMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getChildrenModule = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    // url: baseURL + "/api/setupchildrenmodule/getall",
    url: baseURL + "/api/setupchildrenmodule/getallchild",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETCHILDRENMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getChildrenModuleAdmin = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupchildrenmodule/getalladmin",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETCHILDRENMODULEADMIN,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateChildrenModule = (data) => (dispatch) => {
  var config = {
    method: "patch",
    // url: baseURL + "/api/setupchildrenmodule/update",
    url: baseURL + "/api/setupchildrenmodule/updateall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATECHILDRENMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteChildrenModule = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupchildrenmodule/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETECHILDRENMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getallChildrenModule = (UserData) => (dispatch) => {
  var config = {
    method: "get",
    // url: baseURL+'/api/users/userrole',
    url: baseURL + "/api/setupchildrenmodule/getallmodule",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: UserData,
  };

  axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data));
      dispatch({
        type: GETALLCHILDRENMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayment18 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getallpayment18",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENT18,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createPayment18 = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/createpayment18",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPAYMENT18,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updatePayment18 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuppayment/updatepayment18",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPAYMENT18,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const deletePayment18 = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuppayment/delete18",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPAYMENT18,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createBranch = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/hospitalbranch/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEBRANCH,
        payload: response.data,
      });

      return response;
    })
    .catch(function (error) {
      console.error("Error in createBranch action:", error);

      throw error;
    });
};

export const getBranch = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/hospitalbranch/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETBRANCH,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.error("Error in getBranch action:", error);
    });
};

export const updateBranch = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/hospitalbranch/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEBRANCH,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.error("Error in updateBranch action:", error);

      throw error;
    });
};

export const deleteBranch = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/hospitalbranch/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEBRANCH,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.error("Error in deleteBranch action:", error);

      throw error;
    });
};


export const createaminModule = (Moduledata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupmodule/createall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Moduledata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEADMINEMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};


export const createadminChildrenModule = (Moduledata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupchildrenmodule/createall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Moduledata,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEADMINCHILDRENMODULE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};



export const bulkCreateMasterData = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuprole/createbulk", 
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data, 
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: "BULK_CREATE_MASTER_DATA", 
        payload: response.data,
      });
      return response.data;
    })
    .catch(function (error) {
      console.error("Master Bulk Error:", error);
      throw error;
    });
};



export const syncBulkModulesAndPermissions = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupmodule/createbulk", 
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data, 
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: "SYNC_BULK_MODULES",
        payload: response.data,
      });
      return response.data;
    })
    .catch(function (error) {
      console.error("Module Bulk Error:", error);
      throw error;
    });
};


export const updateAllModuleAndChild = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupmodule/updatestatus",

    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEALLMODULEANDCHILD,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};